import {axiosBffFetch, FetcherOptions} from '../../axios/axiosBffFetch';
import type {GlobalAgreementInfoVo} from '../../common/shared/api/nicolas/GlobalAgreementInfoVo.interface';
import type {ApiResultVo} from '../../common/shared/api/nicolas/vo/ApiResultVo.interface';
import {trimUndefinedFromObject} from '../../common/util/trimUndefinedFromObject';

export type GetGlobalAgreementParams = {
  provider: string;
  authToken?: string | null;
  countryCode?: string | null;
  email?: string | null;
  password?: string | null;
  userId?: string | null;
  selfVerifyUuid?: string | null;
};

/**
 * 글로벌 약관 정보 조회
 *
 * Origin: pageNicolasApi.getGlobalAgreements
 * API: POST /auth/v1/${provider}/agreement
 */
export async function postGatewayAuthProviderAgreement(
  params: GetGlobalAgreementParams,
  options?: FetcherOptions
): Promise<ApiResultVo & {result: GlobalAgreementInfoVo}> {
  const response = await axiosBffFetch(
    `/api/gateway/auth/v1/${params.provider}/agreement`,
    {
      method: 'POST',
      data: trimUndefinedFromObject({
        auth_token: params.authToken,
        country_code: params.countryCode,
        email: params.email,
        password: params.password,
        user_id: params.userId,
        self_verify_uuid: params.selfVerifyUuid,
      }),
      headers: {
        'Content-Type': 'application/json',
      },
    },
    options
  );
  return response.data;
}
